import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class Accessibility extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Accessibility Statement - CamAPS FX</title>
                    <meta name="title" content="Accessibility Statement"/>
                    <meta name="description"
                          content="CamDiab is committed to facilitating and improving the accessibility and usability of its digital products for all people, including those with disabilities."/>
                    <meta property="og:locale" content="en"/>
                    <meta name="keywords" content="accessibility statement"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Accessibility Statement</h1>
                                <h3>Version dated September 11, 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    CamDiab is committed to facilitating and improving the accessibility and usability of its digital products for all people, including those with disabilities.
                                </p>
                                <h2>
                                    Conformance status
                                </h2>
                                <p>
                                    CamDiab aims to achieve compliance with the Web Content Accessibility Guidelines (WCAG) version 2.2 Level AA (WCAG 2.2 AA) standards. These guidelines are globally recognized and help make web content more accessible to everyone.
                                </p>
                                <h2>
                                    Additional measures to support accessibility
                                </h2>
                                <p>
                                    CamDiab is taking the following additional steps, among others, to make our digital content easier to use:
                                </p>
                                <ul>
                                    <li>Provide continual accessibility training for our staff</li>
                                    <li>Employ formal accessibility quality assurance methods via third-party assessment</li>
                                    <li>Assign clear accessibility goals and responsibilities</li>
                                </ul>
                                <h2>
                                    Feedback
                                </h2>
                                <p>
                                    We welcome comments on how to improve our digital products for users with disabilities. If you are having difficulty viewing or navigating our content, or notice any content, feature, or functionality that you believe is not fully accessible to people with disabilities, please contact us using our support email: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    We take your feedback seriously and will consider it as we evaluate ways to accommodate all our customers and our overall accessibility policies. Additionally, while we do not control content provided by third-party vendors, we strongly encourage them to provide content that is accessible and user friendly.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
